import { AnySearchConfiguration } from "@utils/search/@types/searchConfiguration";

import { DefaultHitsPerPage } from "@components/Search/SearchResults/StateComponents/HitsPerPage/hitsPerPage.config";
import { BaseSort } from "@components/Search/SearchResults/StateComponents/Sort/sort.config";

export const PREFIX_SEPARATOR = ".";
export const NUMERIC_FILTER_SEPARATOR = ":";
export const FACET_FILTER_SEPARATOR = ";";

// Configuration -> Route
export const DEFAULT_ROUTE: AnySearchConfiguration = {
    hitsPerPage: DefaultHitsPerPage,
    page: 0,
    sortBy: BaseSort.DEFAULT,
};

// Route -> Configuration
export const NUMERIC_FILTER_REGEX = new RegExp(
    `(\\d+|\\*)${NUMERIC_FILTER_SEPARATOR}(\\d+|\\*)`,
);
